import { apiV2 } from 'lib/api/v2'
import useSWR from 'swr'

type Response = {
  monthsToExpire: number
  numberOfEmployeesWithCardsToExpireSoon: number
}

async function fetcher([, corporateId]: [unknown, string?]): Promise<Response> {
  const response = await apiV2.get<Response>(
    'private/card/expiring-soon/count',
    {
      params: {
        corporateId
      }
    }
  )

  return response.data
}

export function useCardsExpireSoonCount(enabled = false, corporateId?: string) {
  return useSWR(enabled ? ['cardsExpireSoonCount', corporateId] : null, fetcher)
}
